'use client';

import config from '@/app/[locale]/wallet/components/commons/config';
import PrizeData from './PrizeData';
import RedeemSection from './RedeemSection';
import { useRedeemSection } from './useRedeemSection';
import Image from 'next/image';

interface Props {
  id: number;
  imageUrl: string;
  points: number;
  name: string;
  description: string;
}

const PrizeDetail = (props: Props): JSX.Element => {
  const [isAuth, missingLoyaltyPoints] = useRedeemSection(props.points);

  return (
    <div className="tw-pb-8 sm:tw-container sm:tw-mx-auto sm:tw-pb-12 sm:tw-pt-4 sm:tw-px-4 lg:tw-px-6 xl:tw-px-8">
      <div className="tw-grid sm:tw-grid-cols-2 sm:tw-gap-4 md:tw-gap-6">
        <div className="tw-sticky" style={{ top: `calc( ${config.NAVBAR_HEIGHT} + 1.5rem)` }}>
          <div className="tw-relative tw-w-full tw-aspect-square">
            <Image
              fill
              src={props.imageUrl}
              alt={props.name}
              className="sm:tw-rounded-lg tw-sticky"
            />
          </div>
        </div>
        <div>
          <PrizeData name={props.name} description={props.description} />
          <RedeemSection
            points={props.points}
            prizeId={props.id}
            isAuth={isAuth}
            missingPoints={missingLoyaltyPoints}
          />
        </div>
      </div>
    </div>
  );
};

export default PrizeDetail;
